const SelectPropertyConstants = {
  APPLICATIONS: 'applications',
  LEASES: 'leases',
  LISTINGS: 'listings',
  PAYMENTS: 'payments',
} as const;

export default SelectPropertyConstants;
